import { createBSTLSearchParams } from "helpers/search-param-helper/search-param-helper";
import { getLocalStorage } from "helpers/local-storage-helper/local-storage-helper";
import { Link } from "types/link";
import { IAppGeneralFeatures } from "types/appFeatures";

export const createWebRedirectUrl = (
	link: Link,
): {
	pathname: string;
	search: string;
} => {
	const hasShowMenuListFeature =
		getLocalStorage<IAppGeneralFeatures>("appFeatures")?.showMenuSectionList ?? false;

	const eatHereResource = link?.eatHereResource;

	// Create search params with link data
	const deliveryOptionId = eatHereResource?.id;
	// If eatHereResource exists we can assume the delivery type is "EAT_AT_RESTAURANT"
	const deliveryOptionType = eatHereResource ? "EAT_AT_RESTAURANT" : undefined;

	const search = createBSTLSearchParams(
		deliveryOptionType,
		deliveryOptionId,
		hasShowMenuListFeature,
	).toString();

	const appAlias = link.app.alias;
	const menu = link?.menu;
	const place = link?.place;

	let pathname = `/${appAlias}`;
	if (place && menu) {
		pathname = `/${appAlias}/${place.id}/${menu.id}`;
	} else if (place && !menu) {
		// Menus route can be accessed with a delivery type in search params
		// Which exists if eatHereResource exists
		if (eatHereResource) pathname = `/${appAlias}/${place.id}/menus`;
		else {
			pathname = `/${appAlias}/${place.id}`;
		}
	}

	return { pathname, search };
};
